export enum MARKETING_OPTIONS {
  optin_email_auction_updates = 'optin_email_auction_updates',
  optin_email_art_news = 'optin_email_art_news',
  optin_email_events = 'optin_email_events',
  optin_email_lot_alerts = 'optin_email_lot_alerts',
  optin_email_consignment_valuations = 'optin_email_consignment_valuations',
  optin_email_education = 'optin_email_education',
  optin_email_real_estate = 'optin_email_real_estate',
}
